import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { MappedTextArea } from "../../components/TextArea";
import { FormActions } from "../FormActions";

export const SMSForm = ({
  title,
  handleSubmit,
  handleClose,
  data,
  titleClassName,
}) => {
  const initialValues = {
    text: "",
  };
  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={Yup.object({
        text: Yup.string().required("SMS Text is a required field"),
      })}
    >
      {({ handleSubmit, isSubmitting }) => (
        <div className="px-10 py-5">
          <h3 className={`${titleClassName}`}>
            <strong>{title}</strong>
          </h3>
          <div className="mt-5">
            <MappedTextArea
              name="text"
              rows={16}
              inputClassName="bg-secondary"
              placeholder="SMS (160 Characters Max)"
              data-testid="sms-text"
            />
          </div>
          <div className="mt-15">
            <FormActions
              handleClose={handleClose}
              handleSubmit={handleSubmit}
              isSubmitting={isSubmitting}
              submitLabel="Submit"
              className="mr-0"
            />
          </div>
        </div>
      )}
    </Formik>
  );
};
